<template>
  <div class="flex flex-col relative">
    <div class="w-80 h-full">
      <div
        v-if="isLoadingSymbol"
        class="flex items-center justify-center h-[470px] w-full"
      >
        <NLoading class="text-brand-primary" />
      </div>

      <NTabs v-else v-model="tabs" class="w-full">
        <NTab :title="t('common.buy')" color="green">
          <OptionBuyOrderForm
            :symbol="symbol"
            :model="model"
            :selected-order="selectedOrder"
            :is-edit-order="isEditOrder"
          />
        </NTab>

        <NTab :title="t('common.sell')" color="red">
          <OptionSellOrderForm
            :symbol="symbol"
            :model="model"
            :selected-order="selectedOrder"
            :is-edit-order="isEditOrder"
          />
        </NTab>
      </NTabs>
    </div>
  </div>
</template>
<script setup lang="ts">
import { ORDER_SIDES_TABS } from '@core/order';
import { onMounted, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { OrderItem } from '@libs/api-reference';

import { OptionSellOrderForm, OptionBuyOrderForm } from '@/modules/order';
import { useLiveSymbolQuery } from '@/modules/symbol';
import { dataLayer } from '@libs/gtm/src';

type OptionOrderFormDialogEmits = {
  (e?: 'tabChange', value?: string): void;
};

type OptionOrderFormDialogProps = {
  type: 'sell' | 'buy';
  model: {
    quantity?: null | number;
    price?: null | number;
    marginSource: { value: number; label: string } | null;
    strategyLegs: { value: string; label: string } | null;
  };
  isEditOrder?: boolean;
  isin: string;
  selectedOrder?: OrderItem;
};

const emits = defineEmits<OptionOrderFormDialogEmits>();
const props = defineProps<OptionOrderFormDialogProps>();

const { t } = useI18n();

const tabs = ref(ORDER_SIDES_TABS[props.type]);
const type = ref(props.type);

const { symbol, isLoadingSymbol } = useLiveSymbolQuery(ref(props.isin));

watch(tabs, () => {
  if (tabs.value === ORDER_SIDES_TABS.buy) {
    type.value = 'buy';
  } else {
    type.value = 'sell';
  }

  emits('tabChange', type.value);
});

onMounted(() => {
  dataLayer.push({
    event: 'orderType',
    type: 'option',
  });
});
</script>
